// src/app/audit/AI/CoPilotV2/components/ChatMessage.js
import React from 'react';
import styled from 'styled-components';
import colors from 'styles/colors';

const ChatMessage = ({ message, isStreaming }) => {
  // Normalize message source identification
  const isUser = message.from === 'user';
  
  // // Debug message format in development
  // if (process.env.NODE_ENV === 'development') {
  //   console.log('Message object:', {
  //     isUser,
  //     messageType: message.type,
  //     messageFrom: message.from,
  //     username: message.username,
  //     content: message.message || message.web_chat_message_text,
  //     raw: message
  //   });
  // }

  const messageContent = message.message || 
                        message.web_chat_message_text || 
                        message.server || 
                        '';
  return (
    <MessageContainer isUser={isUser}>
      <MessageBubble isUser={isUser} isStreaming={isStreaming}>
        {messageContent}
        {isStreaming && <TypingIndicator>...</TypingIndicator>}
      </MessageBubble>
      {process.env.NODE_ENV === 'development' && (
        <DebugInfo>
          {`[${isUser ? 'User': 'Assistant'}] ID: ${message.id || message.web_chat_message_id}`}
        </DebugInfo>
      )}
    </MessageContainer>
  );
};

const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${props => props.isUser ? 'flex-end' : 'flex-start'};
  margin: 8px 0;
`;

const MessageBubble = styled.div`
  max-width: 70%;
  padding: 12px 16px;
  border-radius: 16px;
  background-color: ${props => props.isUser ? colors.primary : colors.background.light};
  color: ${props => props.isUser ? colors.text.white : colors.text.dark};
  opacity: ${props => props.isStreaming ? 0.7 : 1};
  white-space: pre-wrap; // Preserve message formatting
  word-break: break-word; // Handle long words
`;

const TypingIndicator = styled.span`
  margin-left: 4px;
  animation: blink 1s infinite;
  
  @keyframes blink {
    0% { opacity: .2; }
    20% { opacity: 1; }
    100% { opacity: .2; }
  }
`;

const DebugInfo = styled.div`
  font-size: 10px;
  color: #666;
  margin-top: 2px;
  opacity: 0.7;
`;

export default ChatMessage;